/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ToDoItemDetails } from './ToDoItemDetails';
import {
    ToDoItemDetailsFromJSON,
    ToDoItemDetailsFromJSONTyped,
    ToDoItemDetailsToJSON,
} from './ToDoItemDetails';

/**
 * 
 * @export
 * @interface ToDoItem
 */
export interface ToDoItem {
    /**
     * 
     * @type {string}
     * @memberof ToDoItem
     */
    investmentName: string;
    /**
     * 
     * @type {string}
     * @memberof ToDoItem
     */
    investmentNumber: string;
    /**
     * 
     * @type {ToDoItemDetails}
     * @memberof ToDoItem
     */
    details: ToDoItemDetails;
}

/**
 * Check if a given object implements the ToDoItem interface.
 */
export function instanceOfToDoItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "investmentName" in value;
    isInstance = isInstance && "investmentNumber" in value;
    isInstance = isInstance && "details" in value;

    return isInstance;
}

export function ToDoItemFromJSON(json: any): ToDoItem {
    return ToDoItemFromJSONTyped(json, false);
}

export function ToDoItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToDoItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'investmentName': json['InvestmentName'],
        'investmentNumber': json['InvestmentNumber'],
        'details': ToDoItemDetailsFromJSON(json['Details']),
    };
}

export function ToDoItemToJSON(value?: ToDoItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'InvestmentName': value.investmentName,
        'InvestmentNumber': value.investmentNumber,
        'Details': ToDoItemDetailsToJSON(value.details),
    };
}

